import { useEffect, useState } from "react";
import "./ViewSummerCampModal.css";
import { useSummerCamp } from "../../../../../APIContext/summerCampContext";
import { useNavigate } from "react-router-dom";

const ViewSummerCampModal = ({ open, onClose, id }) => {
  const [data, setData] = useState(null);
  const [openWeek, setOpenWeek] = useState(null);
  const { summercampfordashboardbyid } = useSummerCamp();
  const navigate = useNavigate();
  const getCurrentYear = () => new Date().getFullYear();

  useEffect(() => {
    if (!id || !open) return;

    const fetchData = async () => {
      const result = await summercampfordashboardbyid(id);
      if (result) setData(result);
      else navigate("/login");
    };

    fetchData();
  }, [id, open, summercampfordashboardbyid, navigate]);

  if (!open || !data) return null;

  // Group players by week
  const groupedWeeks = data.week_selections.reduce((acc, item) => {
    if (!acc[item.week_number]) {
      acc[item.week_number] = {
        week: item.week_number,
        start: item.start_datetime_utc,
        end: item.end_datetime_utc,
        location: item.location?.name,
        players: [],
      };
    }

    acc[item.week_number].players.push({
      id: item.id,
      name: item.player_name,
      medical: item.medical_note,
    });

    return acc;
  }, {});

  return (
    <div className="sc-overlay" onClick={onClose}>
      <div className="sc-modal brightness" onClick={(e) => e.stopPropagation()}>
        <div className="sc-header">
          <div>
            <h2>{data.offering_name}</h2>
            <p className="text-clip">SUMMER CAMP · {getCurrentYear()}</p>
          </div>
        </div>

        {/* BODY */}
        <div className="sc-body bg-custom brightness">
          {Object.values(groupedWeeks).map((week) => (
            <div key={week.week} className="accordion">
              <div
                className="accordion-header"
                onClick={() =>
                  setOpenWeek(openWeek === week.week ? null : week.week)
                }
              >
                <div className="week-info">
                  <span className="week-circle brightness">
                    <span className="text-clip">{week.week}</span>
                  </span>
                  <div>
                    <h4 className="text-clip">Week {week.week}</h4>
                    <p className="text-clip">
                      {new Date(week.start).toLocaleDateString()} –{" "}
                      {new Date(week.end).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <span className="text-clip">{openWeek === week.week ? "▲" : "▼"}</span>
              </div>

              {openWeek === week.week && (
                <div className="accordion-body bg-custom">
                  {week.players.map((p) => (
                    <div className="player-card bg-custom" key={p.id}>
                      <h5 className="text-clip">{p.name}</h5>
                      <p className="text-clip">📍 {week.location}</p>
                      <p className="medical text-clip">🩺 {p.medical || "N/A"}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="sc-footer bg-custom brightness">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ViewSummerCampModal;
